export function currentUserSelector(state) {
  const { auth: { currentUserId }, entities: { users } } = state;
  if (currentUserId === null) {
    return null;
  }
  return users.byId[currentUserId] || null;
}



// WEBPACK FOOTER //
// ./src/selectors/userSelectors.js